import { useCallback, useRef, useState } from 'react';
import { animated, useTransition } from '@react-spring/web';
import useOnClickOutside from '@/presentation/hooks/useOnClickOutside';
import SettingsButton from './SettingsButton';
import SettingsContainer from './SettingsContainer';

export function SettingsWrapper() {
  const settingsRef = useRef(null);
  const [showSettings, setShowSettings] = useState(false);

  const transitions = useTransition(showSettings, {
    config: {
      duration: 150,
    },
    from: { opacity: 0, transform: 'translate3d(0,-10%,0)' },
    enter: { opacity: 1, transform: 'translate3d(0,0%,0)' },
    leave: { opacity: 0, transform: 'translate3d(0,-10%,0)' },
  });

  const outsideClickHandler = useCallback(
    () => showSettings && setShowSettings(false),
    [showSettings]
  );

  useOnClickOutside(settingsRef, outsideClickHandler);

  return (
    <div ref={settingsRef}>
      <SettingsButton onClick={() => setShowSettings((x) => !x)} />
      {transitions(
        (style, show) =>
          show && (
            <animated.div
              style={style}
              className="absolute -right-2 top-full border border-gray-200 bg-gray-50 p-4 shadow-lg rounded-lg z-10"
            >
              <SettingsContainer />
            </animated.div>
          )
      )}
    </div>
  );
}

export default SettingsWrapper;
